export default __webpack_public_path__ + "static/media/inventory-item-variant.5e686433.svg";